angular.module('tgaAdmin').controller('AnalyticsController', [
  '$scope',
  '$state',
  '$timeout',
  'gameService',
  'playerService',
  'statsService',
  'reportService',
  '$filter',
  '$uibModal',
  'userService',
  'ngIntroService',
  'instructorService',
  'tzService',
  '$log',
  'settingsService',
  'modalService',
  function (
    $scope,
    $state,
    $timeout,
    gameService,
    playerService,
    statsService,
    reportService,
    $filter,
    $uibModal,
    userService,
    ngIntroService,
    instructorService,
    tzService,
    $log,
    settingsService,
    modalService,
  ) {
    $scope.showBack = false;

    $scope.data = {
      alerts: [],
      filedate: moment().format('YYYY-MM-DD HH-mm-ss'),
      game_id: parseInt($state.params.game_id, 10) || null,
      separator: ',',
      decimalSeparator: '.',
      countupOptions: {
        useEasing: true,
        useGrouping: true,
        separator: ',',
        decimal: ':',
      },
      predicates: [
        {
          name: 'Name',
          value: 'display_name',
        },
        {
          name: 'Email',
          value: 'email',
        },
      ],
      defaultPredicates: [
        {
          name: 'Name',
          value: 'display_name',
        },
        {
          name: 'Email',
          value: 'email',
        },
      ],
      datePickerOptions: settingsService.getDatePickerOptions(
        {},
        {
          'apply.daterangepicker': function (ev, picker) {
            $scope.viewmodel.range = picker.chosenLabel;

            if (
              !$scope.viewmodel.dateRange.startDate.isSame($scope.viewmodel.oldRange.startDate, 'day') ||
              !$scope.viewmodel.dateRange.endDate.isSame($scope.viewmodel.oldRange.endDate, 'day')
            ) {
              $scope.viewmodel.dateRange = $scope.viewmodel.oldRange = {
                startDate: picker.startDate,
                endDate: picker.endDate,
              };
              $scope.$broadcast('updatedDatepickerRange');
              $scope.actions.loadQuestions();
              $scope.actions.loadChart();
              $scope.actions.loadInstructor();
            }
          },
          'outsideClick.daterangepicker': function () {
            $scope.viewmodel.dateRange = {
              startDate: $scope.viewmodel.oldRange.startDate,
              endDate: $scope.viewmodel.oldRange.endDate,
            };
          },
        },
      ),
      chartOptions: {
        series: [
          {
            name: 'Sessions',
            data: [],
          },
          {
            name: 'Players',
            data: [],
          },
        ],
        chart: {
          height: 250,
          type: 'line',
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
          animations: {
            enabled: false,
          },
        },
        legend: {
          position: 'top',
          horizontalAlign: 'center',
          offsetY: 15,
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'straight',
          width: 4,
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [],
          labels: {
            rotate: 0,
          },
        },
        yaxis: [
          {
            seriesName: 'Sessions',
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: '#008FFB',
            },
            labels: {
              style: {
                colors: '#008FFB',
              },
            },
            title: {
              text: 'Sessions',
              style: {
                color: '#008FFB',
              },
            },
          },
          {
            seriesName: 'Players',
            opposite: true,
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: '#00E396',
            },
            labels: {
              style: {
                colors: '#00E396',
              },
            },
            title: {
              text: 'Players',
              style: {
                color: '#00E396',
              },
            },
          },
        ],
      },
    };

    $scope.selectedPredicate = $scope.data.predicates[0].value;

    $scope.viewmodel = {
      showChart: false,
      game: {},
      players: [],
      questions: [],
      session_groups: [],
      range: 'Last 30 Days',
      oldRange: {
        startDate: moment().subtract(29, 'days').startOf('day'),
        endDate: moment().endOf('day'),
      },
      dateRange: {
        startDate: $state.params.dateRange?.startDate
          ? $state.params.dateRange.startDate
          : moment().subtract(29, 'days').startOf('day'),
        endDate: $state.params.dateRange?.endDate ? $state.params.dateRange.endDate : moment().endOf('day'),
      },
      filteredCollection: [],
    };
    // #aside [ui-sref="v1.settings"]
    $scope.introOptions = {
      steps: [
        {
          element: '#aside .nav',
          intro: 'The new game-specific submenu allows you to easily manage everything for your game.',
          position: 'right',
        },
        {
          element: '#aside [ui-sref="v1.gameAccess({ game_id: viewmodel.game_id })"]',
          intro: 'The new <em>Permissions</em> page lets you control which users can access or edit the game.',
          position: 'right',
        },
      ],
      showStepNumbers: false,
      showBullets: false,
      showProgress: true,
      scrollToElement: true,
      scrollPadding: 200,
      exitOnOverlayClick: false,
      exitOnEsc: false,
      nextLabel: 'Next',
      prevLabel: 'Previous',
      skipLabel: 'Exit',
      doneLabel: 'Done',
    };

    $scope.initialize = function () {
      $scope.actions.getGame();

      // Intro
      userService.getData('intro2').then((val) => {
        if (!val) {
          $timeout(() => {
            ngIntroService.clear();
            ngIntroService.setOptions($scope.introOptions);
            ngIntroService.start();

            let currentStep = null;
            let enablePrev = true;

            $('a.introjs-prevbutton').removeClass('introjs-disabled');

            ngIntroService.onAfterChange(() => {
              // eslint-disable-next-line no-underscore-dangle
              currentStep = ngIntroService.intro._currentStep;
              enablePrev = false;
              $('a.introjs-prevbutton').unbind();

              if (currentStep === 0 && !enablePrev) {
                $('a.introjs-prevbutton').removeClass('introjs-disabled');
                $scope.actions.prevClick();
              }
            });

            if (enablePrev) {
              $('a.introjs-prevbutton').unbind();
              $scope.actions.prevClick();
            }

            ngIntroService.onComplete(() => {
              userService.setData('intro2', true);
              $state.go('v1.games');
            });

            ngIntroService.onExit(() => {
              userService.setData('intro2', true);
            });
          }, 500);
        }
      });
    };

    $scope.getters = {
      sortQuestionText: function sortQuestionText(row) {
        return $filter('questionText')(row);
      },
      sortQuestionType: function sortQuestionType(row) {
        return $filter('questionType')(row.question_type);
      },
      sortQuestionCorrect: function sortQuestionCorrect(row) {
        return row.total_correct / (row.total_answered || 1);
      },
      sortQuestionIncorrect: function sortQuestionIncorrect(row) {
        return row.total_incorrect / (row.total_answered || 1);
      },
      sortQuestionCorrectFirst: function sortQuestionCorrectFirst(row) {
        return row.total_correct_first / (row.total_first || 1);
      },
      sortQuestionIncorrectFirst: function sortQuestionIncorrectFirst(row) {
        return row.total_incorrect_first / (row.total_first || 1);
      },
      sortQuestionCorrectSecond: function sortQuestionCorrectSecond(row) {
        return row.total_correct_second / (row.total_second || 1);
      },
      sortQuestionIncorrectSecond: function sortQuestionIncorrectSecond(row) {
        return row.total_incorrect_second / (row.total_second || 1);
      },
      sortQuestionCorrectThird: function sortQuestionCorrectThird(row) {
        return row.total_correct_third / (row.total_third || 1);
      },
      sortQuestionIncorrectThird: function sortQuestionIncorrectThird(row) {
        return row.total_incorrect_third / (row.total_third || 1);
      },
    };

    $scope.actions = {
      prevClick() {
        $('a.introjs-prevbutton').click(() => {
          ngIntroService.clear();
          userService.setData('intro1', false);
          userService.setData('intro2', false);
          $state.go('v1.games', { lastStep: true });
        });
      },
      toggleChart() {
        $scope.viewmodel.showChart = !$scope.viewmodel.showChart;
      },
      getGame() {
        $scope.viewmodel.required_fields = [];
        $scope.viewmodel.custom_fields = [];
        $scope.viewmodel.divisions = [];

        $scope.actions.loadQuestions();
        $scope.actions.loadChart();
        $scope.actions.loadInstructor();
        $scope.loadingGame = true;

        gameService
          .getGame($scope.data.game_id)
          .then((game) => {
            $scope.viewmodel.game = game;

            $scope.title = `<span class="text-muted">Analytics /</span> <span class="text-capitalize">${$scope.viewmodel.game.name}</span>`;

            if ($scope.viewmodel.game.registration.required) {
              for (let i = 0; i < $scope.viewmodel.game.registration.fields.length; i++) {
                if (
                  $scope.viewmodel.game.registration.fields[i].condition === 'required' ||
                  $scope.viewmodel.game.registration.fields[i].condition === 'optional'
                ) {
                  const requiredField = $scope.viewmodel.game.registration.fields[i].key;
                  $scope.viewmodel.required_fields.push(requiredField);
                }
              }

              for (let i = 0; i < $scope.viewmodel.game.registration.custom_fields.length; i++) {
                if (
                  $scope.viewmodel.game.registration.custom_fields[i].condition === 'required' ||
                  $scope.viewmodel.game.registration.custom_fields[i].condition === 'optional'
                ) {
                  const customField = $scope.viewmodel.game.registration.custom_fields[i];
                  $scope.viewmodel.custom_fields.push(customField);
                }
              }
            } else {
              // Always show email column
              $scope.viewmodel.required_fields.push('email');
            }
            // Always show username
            $scope.viewmodel.required_fields.push('username');

            if ($scope.viewmodel.game.divisions.length) {
              for (let i = 0; i < $scope.viewmodel.game.divisions.length; i++) {
                const division = $scope.viewmodel.game.divisions[i];
                $scope.viewmodel.divisions.push(division);
              }
            }

            $scope.loadingGame = false;
          })
          .catch((e) => {
            if (e.code === 'EXPIRED') {
              $timeout(() => {
                modalService
                  .showModal({
                    title: 'Game Subscription Expired',
                    message: 'Upgrade your account to access this game type.',
                    closeButton: false,
                    actionButton: 'OK',
                  })
                  .then(() => {
                    $state.go('v1.account', {
                      tab: 'subscriptions',
                    });
                  });
              }, 0);
            } else {
              $state.go('v1.games');
            }
          });
      },
      loadChart() {
        $scope.loadingChart = true;

        statsService
          .getOverviewChart(
            $scope.data.game_id,
            $scope.viewmodel.dateRange.startDate.toISOString(true),
            $scope.viewmodel.dateRange.endDate.toISOString(true),
          )
          .then((response) => {
            $scope.data.chartOptions.series = [
              {
                name: 'Sessions',
                data: response.sessions,
              },
              {
                name: 'Players',
                data: response.players,
              },
            ];

            $scope.data.chartOptions.xaxis.categories = response.xaxis;

            $scope.loadingChart = false;
          });
      },
      loadInstructor() {
        const startDate = $scope.viewmodel.dateRange.startDate.toISOString(true);
        const endDate = $scope.viewmodel.dateRange.endDate.toISOString(true);

        $scope.loadingInstructor = true;
        $scope.viewmodel.session_groups = [];

        instructorService.getSessionGroups($scope.data.game_id, startDate, endDate).then((data) => {
          $scope.viewmodel.session_groups = data;
          $scope.loadingInstructor = false;
        });
      },
      loadUsers(tableState) {
        if (tableState) $scope.currTableState = tableState;
        const startDate = $scope.viewmodel.dateRange.startDate.toISOString(true);
        const endDate = $scope.viewmodel.dateRange.endDate.toISOString(true);

        $scope.loadingUsers = true;

        statsService.getSessionStats($scope.data.game_id, startDate, endDate).then((stats) => {
          const avg_time = $filter('formatDuration')(stats.average_time).split(':');
          $scope.viewmodel.average_time = parseFloat(`${avg_time[1]}.${avg_time[2]}`);
          $scope.viewmodel.total_sessions = stats.total_sessions;
          $scope.viewmodel.completed_sessions = stats.completed_sessions;
          $scope.viewmodel.average_score = stats.average_score || 0;
          $scope.viewmodel.average_accuracy = stats.average_accuracy || 0;
          $scope.viewmodel.accuracy_first = stats.accuracy_first || 0;
          $scope.viewmodel.accuracy_second = stats.accuracy_second || 0;
          $scope.viewmodel.accuracy_third = stats.accuracy_third || 0;
          $scope.viewmodel.total_players = stats.total_players || 0;
          $scope.viewmodel.average_turns = stats.average_turns || 0;
          $scope.viewmodel.average_questions_completed = stats.average_questions_completed || 0;
          $scope.viewmodel.total_game_questions = $scope.viewmodel.game.question_groups.reduce(
            (total, question_groups) => total + question_groups.questions.length,
            0,
          );

          if (stats.first_date) {
            $scope.data.datePickerOptions.ranges['All Time'] = [moment(stats.first_date).startOf('month'), moment()];
          }
        });

        playerService.getNewPlayers($scope.data.game_id, startDate, endDate).then((total) => {
          $scope.viewmodel.new_players = total;
        });

        playerService.getPlayers($scope.actions.getPagedParams(tableState)).then((response) => {
          $scope.viewmodel.players = response.items || response;
          $scope.loadingUsers = false;
          if (tableState) {
            tableState.pagination.numberOfPages = Math.ceil(response.total / tableState.pagination.number);
            tableState.pagination.totalItemCount = response.total;
          }
        });
      },
      getPagedParams(tableState) {
        const { endDate, startDate } = $scope.viewmodel.dateRange;
        const params = tableState
          ? {
              paginate: true,
              page: Math.floor(tableState.pagination.start / tableState.pagination.number) + 1,
              limit: tableState.pagination.number,
              sort: tableState.sort.predicate,
              order: tableState.sort.reverse ? 'desc' : 'asc',
              start_date: startDate.toISOString(true),
              end_date: endDate.toISOString(true),
              game_id: $scope.data.game_id,
            }
          : {
              paginate: true,
              page: 1,
              start_date: startDate ? new Date(startDate) : null,
              end_date: endDate ? new Date(endDate) : null,
              game_id: $scope.data.game_id,
            };

        if (tableState?.search?.predicateObject) {
          Object.keys(tableState.search.predicateObject).forEach((key) => {
            // Check for divisions first and set values to a divisions array
            if (key === 'divisions') {
              params['divisions[]'] = Object.keys(tableState.search.predicateObject.divisions).map(
                (divisionKey) => tableState.search.predicateObject.divisions[divisionKey].value,
              );
            } else {
              params[key] = tableState.search.predicateObject[key];
            }
          });
        }

        return params;
      },
      loadQuestions() {
        $scope.loadingQuestions = true;

        $scope.viewmodel.questions = [];

        statsService
          .getQuestionStats(
            $scope.data.game_id,
            $scope.viewmodel.dateRange.startDate.toISOString(true),
            $scope.viewmodel.dateRange.endDate.toISOString(true),
          )
          .then((response) => {
            $scope.viewmodel.questions = response.filter((question) => question.question_type !== 'interstitial');
            $scope.loadingQuestions = false;
          });
      },
      questionDetails(question) {
        $uibModal
          .open({
            animation: true,
            templateUrl: 'templates/views/question-details.html',
            controller: 'QuestionDetailsController',
            size: 'lg',
            backdrop: true,
            resolve: {
              extra() {
                return {
                  game: $scope.viewmodel.game,
                  question,
                  startDate: $scope.viewmodel.dateRange.startDate,
                  endDate: $scope.viewmodel.dateRange.endDate,
                };
              },
            },
          })
          .result.catch(angular.noop);
      },
      playerDetails(player) {
        $uibModal
          .open({
            animation: true,
            templateUrl: 'templates/views/player.html',
            controller: 'PlayerController',
            size: 'lg',
            backdrop: true,
            resolve: {
              extra() {
                return {
                  player,
                  game: $scope.viewmodel.game,
                  game_id: $scope.data.game_id,
                  required_fields: $scope.viewmodel.required_fields,
                  startDate: $scope.viewmodel.dateRange.startDate,
                  endDate: $scope.viewmodel.dateRange.endDate,
                };
              },
            },
          })
          .result.catch(angular.noop);
      },
      sumAccuracyBySession(sessionNum) {
        let totalPlayers = 0;
        let sum = 0;

        for (let i = 0; i < $scope.viewmodel.filteredCollection.length; i++) {
          const player = $scope.viewmodel.filteredCollection[i];

          if (angular.isDefined(player.sessions[sessionNum])) {
            sum += player.sessions[sessionNum].accuracy || 0;
            totalPlayers++;
          }
        }

        return sum / (totalPlayers || 1);
      },
      exportStats() {
        if (!$scope.viewmodel.players.length) {
          return false;
        }

        $scope.exporting = true;

        return playerService
          .getPlayers({
            game_id: $scope.data.game_id,
            start_date: $scope.viewmodel.dateRange.startDate.toISOString(true),
            end_date: $scope.viewmodel.dateRange.endDate.toISOString(true),
            extended: true,
          })
          .then((response) => {
            const players = response;

            const workbook = new ExcelJS.Workbook();
            workbook.creator = 'The Training Arcade';

            // Overview
            let worksheet = workbook.addWorksheet('Overview');
            const gameType = $scope.viewmodel.game.game_type;
            const questionName = gameType === 'category_quest' ? 'Puzzles' : 'Questions';

            // add column headers
            let header = [
              { header: 'Player', key: 'player', width: 12 },
              { header: 'Rank', key: 'rank', width: 12 },
              { header: 'High Score', key: 'high_score', width: 12 },
              { header: 'Avg. Score', key: 'avg_score', width: 12 },
              { header: 'Total Sessions', key: 'total_sessions', width: 12 },
              { header: 'Completed Sessions', key: 'total_complete', width: 12 },
              { header: 'Avg. Duration', key: 'average_time', width: 12 },
              { header: `Total ${questionName}`, key: 'total_answered', width: 12 },
              { header: 'Accuracy', key: 'accuracy', width: 12 },
              { header: '1st Session', key: 'accuracy_1', width: 12 },
              { header: '2nd Session', key: 'accuracy_2', width: 12 },
              { header: '3rd Session', key: 'accuracy_3', width: 12 },
              { header: 'Unique Username', key: 'username', width: 12 },
            ];

            if (gameType === 'category_quest') {
              header.push({ header: 'Avg. Turn Count', key: 'turn_count', width: 12 });
              header.push({ header: 'Avg. Content Seen', key: 'content_seen', width: 12 });
            }

            if ($scope.viewmodel.game.registration.required === true) {
              for (let i = 0; i < $scope.viewmodel.game.registration.fields.length; i++) {
                if ($scope.viewmodel.game.registration.fields[i].condition !== null) {
                  header.push({
                    header: $scope.viewmodel.game.registration.fields[i].label,
                    key: $scope.viewmodel.game.registration.fields[i].key,
                  });
                }
              }

              for (let i = 0; i < $scope.viewmodel.custom_fields.length; i++) {
                header.push({
                  header: $scope.viewmodel.custom_fields[i].label,
                  key: `custom_field_${$scope.viewmodel.custom_fields[i].custom_field_id}`,
                });
              }
            } else {
              header.push({
                header: 'Email Address',
                key: 'email',
              });
            }

            worksheet.columns = header;

            for (let j = 0; j < players.length; j++) {
              const avg_time = $filter('formatDuration')(players[j].average_time).split(':');

              const rowData = {
                player: players[j].full_name ? players[j].full_name : players[j].display_name,
                rank: players[j].rank,
                high_score: players[j].high_score,
                avg_score: players[j].avg_score,
                total_sessions: players[j].total_sessions,
                total_complete: players[j].total_complete,
                average_time: {
                  formula: `TIME(${avg_time[0]},${avg_time[1]},${avg_time[2]}) + INT(${avg_time[0]}/ 24)`,
                },
                total_answered: players[j].total_answered,
                accuracy: players[j].total_correct / (players[j].total_answered || 1),
                accuracy_1: players[j].sessions[0] ? parseFloat(players[j].sessions[0].accuracy) : null,
                accuracy_2: players[j].sessions[1] ? parseFloat(players[j].sessions[1].accuracy) : null,
                accuracy_3: players[j].sessions[2] ? parseFloat(players[j].sessions[2].accuracy) : null,
                username: players[j].username,
              };

              if (gameType === 'category_quest') {
                rowData['turn_cont'] = $scope.viewmodel.average_turns;
                rowData['content_seen'] =
                  ($scope.viewmodel.questions.length / $scope.viewmodel.total_game_questions) * 100;
              }

              if ($scope.viewmodel.game.registration.required === true) {
                for (let i = 0; i < $scope.viewmodel.game.registration.fields.length; i++) {
                  if ($scope.viewmodel.game.registration.fields[i].condition !== null) {
                    // eslint-disable-next-line max-len
                    rowData[$scope.viewmodel.game.registration.fields[i].key] =
                      players[j][$scope.viewmodel.game.registration.fields[i].key];
                  }
                }

                for (let i = 0; i < $scope.viewmodel.custom_fields.length; i++) {
                  if (
                    players[j].custom_fields &&
                    players[j].custom_fields[`custom_field_${$scope.viewmodel.custom_fields[i].custom_field_id}`]
                  ) {
                    // eslint-disable-next-line max-len
                    rowData[`custom_field_${$scope.viewmodel.custom_fields[i].custom_field_id}`] =
                      players[j].custom_fields[
                        `custom_field_${$scope.viewmodel.custom_fields[i].custom_field_id}`
                      ].text;
                  }
                }
              } else {
                rowData.email = players[j].email;
              }
              worksheet.addRow(rowData);
            }

            worksheet.getColumn(7).numFmt = '[h]:mm:ss';
            worksheet.getColumn(8).numFmt = null;
            worksheet.getColumn(9).numFmt = '0.00%';
            worksheet.getColumn(10).numFmt = '0.00%';
            worksheet.getColumn(11).numFmt = '0.00%';
            worksheet.getColumn(12).numFmt = '0.00%';

            worksheet.getRow(1).font = { bold: true };

            worksheet.views = [{ state: 'frozen', ySplit: 1 }];

            worksheet.properties.outlineProperties = {
              summaryBelow: false,
              summaryRight: false,
            };

            // Sessions
            worksheet = workbook.addWorksheet('Sessions');

            // add column headers
            header = [
              { header: 'Player', key: 'player', width: 12 },
              { header: 'Player ID', key: 'id', width: 12 },
              { header: 'Session #', key: 'session_num', width: 12 },
              { header: 'Team', key: 'team_name', width: 12 },
              { header: 'Date', key: 'session_date', width: 12 },
              { header: 'Duration', key: 'session_duration', width: 12 },
              { header: 'Duration (s)', key: 'session_seconds', width: 12 },
              { header: 'Status', key: 'complete', width: 12 },
              { header: 'Session Score', key: 'session_score', width: 12 },
              { header: `Total ${questionName}`, key: 'total_answered', width: 12 },
              { header: `${questionName} Correct`, key: 'questions_correct', width: 12 },
              { header: `${questionName} Text`, key: 'question_text', width: 12 },
              { header: 'Correct/Incorrect', key: 'correct_incorrect', width: 12 },
              { header: 'Answer', key: 'answer', width: 12 },
              { header: `${questionName} Duration`, key: 'question_duration', width: 12 },
              { header: `${questionName} Score`, key: 'question_score', width: 12 },
              { header: 'Unique Username', key: 'username', width: 12 },
            ];

            if ($scope.viewmodel.game.registration.required === true) {
              for (let i = 0; i < $scope.viewmodel.game.registration.fields.length; i++) {
                if ($scope.viewmodel.game.registration.fields[i].condition !== null) {
                  header.push({
                    header: $scope.viewmodel.game.registration.fields[i].label,
                    key: $scope.viewmodel.game.registration.fields[i].key,
                  });
                }
              }

              for (let i = 0; i < $scope.viewmodel.custom_fields.length; i++) {
                header.push({
                  header: $scope.viewmodel.custom_fields[i].label,
                  key: `custom_field_${$scope.viewmodel.custom_fields[i].custom_field_id}`,
                });
              }
            } else {
              header.push({
                header: 'Email Address',
                key: 'email',
              });
            }

            worksheet.columns = header;

            let row = 2;
            const collapseRows = [];

            players.forEach((player) => {
              player.sessions.forEach((session, session_num) => {
                const session_time = $filter('formatDuration')(session.time).split(':');

                const rowData = {
                  player: player.full_name ? player.full_name : player.display_name,
                  id: player.id,
                  session_num: `Session ${session_num + 1}`,
                  team_name: session.team_name,
                  session_date: tzService.parseFormatUserDate(session.date_created, 'YYYY-MM-DD HH:mm:ss'),
                  session_duration: {
                    formula: `TIME(${session_time[0]},${session_time[1]},${session_time[2]}) + INT(${session_time[0]}/ 24)`,
                  },
                  session_seconds: session.time / 1000.0, // milliseconds -> seconds
                  complete: session.complete ? 'Complete' : 'Incomplete',
                  session_score: session.points,
                  total_answered: session.total_answered,
                  questions_correct: session.total_correct / (session.total_answered || 1),
                  username: player.username,
                };

                if ($scope.viewmodel.game.registration.required === true) {
                  for (let i = 0; i < $scope.viewmodel.game.registration.fields.length; i++) {
                    if ($scope.viewmodel.game.registration.fields[i].condition !== null) {
                      // eslint-disable-next-line max-len
                      rowData[$scope.viewmodel.game.registration.fields[i].key] =
                        player[$scope.viewmodel.game.registration.fields[i].key];
                    }
                  }

                  for (let i = 0; i < $scope.viewmodel.custom_fields.length; i++) {
                    if (
                      player.custom_fields &&
                      player.custom_fields[`custom_field_${$scope.viewmodel.custom_fields[i].custom_field_id}`]
                    ) {
                      // eslint-disable-next-line max-len
                      rowData[`custom_field_${$scope.viewmodel.custom_fields[i].custom_field_id}`] =
                        player.custom_fields[`custom_field_${$scope.viewmodel.custom_fields[i].custom_field_id}`].text;
                    }
                  }
                } else {
                  rowData.email = player.email;
                }

                worksheet.addRow(rowData);
                row++;

                if (session.questions.length) {
                  collapseRows.push({ start: row, end: row + session.questions.length });
                }

                session.questions.forEach((question) => {
                  let correctIncorrect = null;
                  let answer = null;

                  if (question.answers && question.answers.length) {
                    answer = question.answers.map((elem) => elem.text).join(', ');
                  }

                  if (question.question_type !== 'poll') {
                    correctIncorrect = question.correct ? 'Correct' : 'Incorrect';
                  }

                  const question_time = $filter('formatDuration')(question.time).split(':');

                  worksheet.addRow({
                    question_text: $filter('questionText')(question),
                    correct_incorrect: correctIncorrect,
                    answer: $filter('htmlToPlaintext')(answer),
                    question_duration: {
                      formula: `TIME(${question_time[0]},${question_time[1]},${question_time[2]}) + INT(${question_time[0]}/ 24)`,
                    },
                    question_score: question.points,
                  });

                  row++;
                });
              });
            });

            collapseRows.forEach((collapseRow) => {
              for (let i = collapseRow.start; i < collapseRow.end; i++) {
                worksheet.getRow(i).outlineLevel = 1;
              }
            });

            worksheet.getColumn(6).numFmt = '[h]:mm:ss';
            worksheet.getColumn(11).numFmt = '0.00%';
            worksheet.getColumn(15).numFmt = '[h]:mm:ss';

            worksheet.getRow(1).font = { bold: true };

            worksheet.views = [{ state: 'frozen', ySplit: 1 }];

            worksheet.properties.outlineProperties = {
              summaryBelow: false,
              summaryRight: false,
            };

            // Questions
            worksheet = workbook.addWorksheet(`${questionName}`);

            // add column headers
            header = [
              { header: `${questionName}`, key: 'question', width: 12 },
              { header: 'Avg. Time', key: 'average_time', width: 12 },
              { header: 'Accuracy', key: 'accuracy', width: 12 },
              { header: 'Attempts', key: 'total_answered', width: 12 },
              { header: '1st Attempt', key: 'accuracy_first', width: 12 },
              { header: '2nd Attempt', key: 'accuracy_second', width: 12 },
              { header: '3rd Attempt', key: 'accuracy_third', width: 12 },
            ];

            let hasPoll = false;

            worksheet.columns = header;

            for (let j = 0; j < $scope.viewmodel.questions.length; j++) {
              if ($scope.viewmodel.questions[j].question_type === 'poll') {
                hasPoll = true;
                // eslint-disable-next-line no-continue
                continue;
              }

              const avg_time = $filter('formatDuration')($scope.viewmodel.questions[j].average_time).split(':');

              const rowData = {
                question: $filter('htmlToPlaintext')($scope.viewmodel.questions[j].text),
                average_time: {
                  formula: `TIME(${avg_time[0]},${avg_time[1]},${avg_time[2]}) + INT(${avg_time[0]}/ 24)`,
                },
                accuracy:
                  $scope.viewmodel.questions[j].total_correct / ($scope.viewmodel.questions[j].total_answered || 1),
                total_answered: $scope.viewmodel.questions[j].total_answered,
                accuracy_first:
                  $scope.viewmodel.questions[j].total_correct_first / ($scope.viewmodel.questions[j].total_first || 1),
                accuracy_second:
                  $scope.viewmodel.questions[j].total_correct_second /
                  ($scope.viewmodel.questions[j].total_second || 1),
                accuracy_third:
                  $scope.viewmodel.questions[j].total_correct_third / ($scope.viewmodel.questions[j].total_third || 1),
              };

              worksheet.addRow(rowData);
            }

            worksheet.getColumn(2).numFmt = '[h]:mm:ss';
            worksheet.getColumn(3).numFmt = '0.00%';
            worksheet.getColumn(4).numFmt = null;
            worksheet.getColumn(5).numFmt = '0.00%';
            worksheet.getColumn(6).numFmt = '0.00%';
            worksheet.getColumn(7).numFmt = '0.00%';

            worksheet.getRow(1).font = { bold: true };

            worksheet.views = [{ state: 'frozen', ySplit: 1 }];

            worksheet.properties.outlineProperties = {
              summaryBelow: false,
              summaryRight: false,
            };

            // Poll Questions
            if (hasPoll) {
              worksheet = workbook.addWorksheet('Polls');

              // add column headers
              header = [
                { header: 'Question', key: 'question', width: 12 },
                { header: 'Avg. Time', key: 'average_time', width: 12 },
                { header: 'Answer', key: 'answer', width: 12 },
                { header: 'Total Selected', key: 'total_selected', width: 14 },
                { header: 'Percent Selected', key: 'percent_selected', width: 16 },
                { header: 'Selected By', key: 'player', width: 12 },
                { header: 'Username', key: 'username', width: 12 },
                { header: 'Times Selected', key: 'total', width: 12 },
              ];

              worksheet.columns = header;

              let row = 2;
              const collapseRows = [];

              for (let j = 0; j < $scope.viewmodel.questions.length; j++) {
                const question = $scope.viewmodel.questions[j];

                if (question.question_type === 'poll') {
                  const avg_time = $filter('formatDuration')(question.average_time).split(':');

                  let rowData = {
                    question: $filter('htmlToPlaintext')(question.text),
                    average_time: {
                      formula: `TIME(${avg_time[0]},${avg_time[1]},${avg_time[2]}) + INT(${avg_time[0]}/ 24)`,
                    },
                  };

                  worksheet.addRow(rowData);
                  if (row > 2) {
                    worksheet.getRow(row).border = { top: { style: 'thin' } };
                  }
                  row++;

                  for (let k = 0; k < question.answers.length; k++) {
                    rowData = {
                      question: `Answer ${k + 1}`,
                      average_time: null,
                      answer: question.answers[k].text,
                      total_selected: question.answers[k].total,
                      percent_selected: question.answers[k].percent / 100,
                    };

                    collapseRows.push({ row, level: 1 });
                    worksheet.addRow(rowData);
                    worksheet.getRow(row).getCell(1).font = { italic: true };
                    row++;

                    for (let x = 0; x < question.answers[k].users?.length; x++) {
                      const player = question.answers[k].users[x];

                      rowData = {
                        question: null,
                        average_time: null,
                        answer: null,
                        total_selected: null,
                        percent_selected: null,
                        player: player.full_name ? player.full_name : player.display_name,
                        username: player.username,
                        total: player.total,
                      };

                      collapseRows.push({ row, level: 2 });
                      worksheet.addRow(rowData);
                      row++;
                    }
                  }
                }
              }

              collapseRows.forEach((collapseRow) => {
                worksheet.getRow(collapseRow.row).outlineLevel = collapseRow.level;
              });

              worksheet.getColumn(2).numFmt = '[h]:mm:ss';
              worksheet.getColumn(3).numFmt = null;
              worksheet.getColumn(4).numFmt = null;
              worksheet.getColumn(5).numFmt = '0.00%';

              worksheet.getRow(1).font = { bold: true };

              worksheet.views = [{ state: 'frozen', ySplit: 1 }];

              worksheet.properties.outlineProperties = {
                summaryBelow: false,
                summaryRight: false,
              };
            }

            // save workbook to disk
            workbook.xlsx
              .writeBuffer({ base64: true })
              .then((xls64) => {
                // build anchor tag and attach file (works in chrome)
                // eslint-disable-next-line angular/document-service
                const a = document.createElement('a');
                const data = new Blob([xls64], {
                  type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });

                const url = URL.createObjectURL(data);
                a.href = url;
                a.download = reportService.generateReportFilename(
                  `${$scope.viewmodel.game.name} Stats`,
                  $scope.viewmodel.dateRange.startDate,
                  $scope.viewmodel.dateRange.endDate,
                  'xlsx',
                );
                // eslint-disable-next-line angular/document-service
                document.body.appendChild(a);
                a.click();
                // eslint-disable-next-line angular/timeout-service
                setTimeout(() => {
                  // eslint-disable-next-line angular/document-service
                  document.body.removeChild(a);
                  // eslint-disable-next-line angular/window-service
                  window.URL.revokeObjectURL(url);
                }, 0);
              })
              .catch((error) => {
                $log.log(error.message);
              });

            $scope.exporting = false;
          });
      },
      createAlert(msg, type) {
        $scope.data.alerts = [];
        $scope.data.alerts.push({
          msg,
          type,
        });
      },
    };

    $scope.$on('$destroy', () => {
      ngIntroService.clear();
    });

    $scope.initialize();
  },
]);
